export default () => ({
    packaging: [],
    style: [],
    vendor: [],

    summaryOpen: {
        packaging: true,
        style: false,
        vendor: false,
    },

    get allItems() {
        return this.$store.cart.items ?? [];
    },

    get packagingOptions() {
        return this.buildOptions((item) => item.productVariation?.packaging_type);
    },

    get styleOptions() {
        return this.buildOptions((item) => item.productVariation?.style);
    },

    get vendorOptions() {
        return this.buildOptions((item) => item.productVariation?.vendor);
    },

    buildOptions(pick) {
        const values = new Set();
        this.allItems.forEach((item) => {
            const value = pick(item);
            if (value) values.add(value);
        });

        return [...values]
            .sort((a, b) => a.localeCompare(b, 'ru'))
            .map((value) => ({ value, label: value }));
    },

    get filteredItems() {
        return this.allItems.filter((item) => {
            const pv = item.productVariation ?? {};

            if (
                this.packaging.length > 0 &&
                !this.packaging.includes(pv.packaging_type)
            ) {
                return false;
            }

            if (this.style.length > 0 && !this.style.includes(pv.style)) {
                return false;
            }

            if (this.vendor.length > 0 && !this.vendor.includes(pv.vendor)) {
                return false;
            }

            return true;
        });
    },

    get hasActiveFilters() {
        return (
            this.packaging.length > 0 ||
            this.style.length > 0 ||
            this.vendor.length > 0
        );
    },

    get hiddenCount() {
        return this.allItems.length - this.filteredItems.length;
    },

    summaryBy(pick, fallbackLabel, withBreakdown = false) {
        const byQuantity = (a, b) => b.quantity - a.quantity;
        const groups = new Map();

        this.allItems.forEach((item) => {
            const pv = item.productVariation ?? {};
            const label = pick(pv) || fallbackLabel;
            const quantity = item.quantity ?? 0;
            const amount = item.amountValue ?? 0;

            const group = groups.get(label) ?? {
                label,
                quantity: 0,
                amount: 0,
                breakdown: new Map(),
            };

            group.quantity += quantity;
            group.amount += amount;

            if (withBreakdown) {
                const packagingLabel = pv.packaging_type || 'Без тары';
                const row = group.breakdown.get(packagingLabel) ?? {
                    label: packagingLabel,
                    quantity: 0,
                    amount: 0,
                };
                row.quantity += quantity;
                row.amount += amount;
                group.breakdown.set(packagingLabel, row);
            }

            groups.set(label, group);
        });

        return [...groups.values()]
            .map((group) => ({
                ...group,
                breakdown: [...group.breakdown.values()].sort(byQuantity),
            }))
            .sort(byQuantity);
    },

    get packagingSummary() {
        return this.summaryBy((pv) => pv.packaging_type, 'Без тары');
    },

    get styleSummary() {
        return this.summaryBy((pv) => pv.style, 'Без сорта', true);
    },

    get vendorSummary() {
        return this.summaryBy((pv) => pv.vendor, 'Без производителя', true);
    },

    toggleSummary(key) {
        this.summaryOpen[key] = !this.summaryOpen[key];
    },

    reset() {
        this.packaging = [];
        this.style = [];
        this.vendor = [];
    },

    formatMoney(value) {
        return new Intl.NumberFormat('ru-RU').format(value ?? 0) + ' ₽';
    },
});
